// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/assets/images/webp/meetings-bg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullscreen-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    background: rgba(0, 0, 0, 0.6) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
    background-size: cover;
    z-index: 999;
}

.form-container {
    width: 90%;
    max-width: 600px;
    padding: 30px;
    background: #111827;
    border-radius: 15px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.5);
    text-align: center;
}

form input {
    display: block;
    width: 100%;
    padding: 10px;
    margin: 0;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.form-btn {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    background-color: #2596be;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.form-btn:hover {
    background-color: #1a6d8c;
}

.error {
    color: red;
    margin-bottom: 10px;
}

.toggle-link {
    color: #2596be;
    cursor: pointer;
    text-decoration: underline;
}

.toggle-link:hover {
    color: #1a6d8c;
}
`, "",{"version":3,"sources":["webpack://./src/components/AuthForms.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,mCAAmC;IACnC,8FAA4G;IAC5G,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".fullscreen-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    background: rgba(0, 0, 0, 0.6) url(../../public/assets/images/webp/meetings-bg.webp) no-repeat center center;\n    background-size: cover;\n    z-index: 999;\n}\n\n.form-container {\n    width: 90%;\n    max-width: 600px;\n    padding: 30px;\n    background: #111827;\n    border-radius: 15px;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.5);\n    text-align: center;\n}\n\nform input {\n    display: block;\n    width: 100%;\n    padding: 10px;\n    margin: 0;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n}\n\n.form-btn {\n    width: 100%;\n    padding: 10px;\n    font-size: 16px;\n    font-weight: bold;\n    color: #ffffff;\n    background-color: #2596be;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.form-btn:hover {\n    background-color: #1a6d8c;\n}\n\n.error {\n    color: red;\n    margin-bottom: 10px;\n}\n\n.toggle-link {\n    color: #2596be;\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n.toggle-link:hover {\n    color: #1a6d8c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
